import i18n from "i18next";
import { initReactI18next } from "react-i18next";

void i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: "en",
  interpolation: { escapeValue: false },
  resources: {
    en: {
      translation: {
        applicationName: "IAF Framework Showcase",
        experience: "Application experience",
        experienceCenter: "Experience Center",
        patterns: "Application patterns",
        personalization: "Personalization",
        overview: "Overview",
        records: "Service requests",
        detail: "Detail pattern",
        masterDetail: "Master-detail",
        inlineEditing: "Inline editing",
        themeStudio: "Theme Studio",
        visualizations: "Visualizations",
        states: "States & accessibility",
        businessObjects: "Business objects",
        overviewTitle: "Composable application patterns",
        overviewIntro:
          "A neutral mock-data environment demonstrating reusable Inteacc list, detail, form, lookup, and visualization foundations."
      }
    },
    fr: {
      translation: {
        applicationName: "Vitrine du cadre IAF",
        'Global search': 'Recherche globale',
        'Tasks': 'Tâches',
        'Notifications': 'Notifications',
        'Favorites': 'Favoris',
        'Recently opened': 'Ouvert récemment',
        'Appearance': 'Apparence',
        'Help': 'Aide',
        'User profile': 'Profil utilisateur',
        'Close panel': 'Fermer le panneau',
        'Search applications': 'Rechercher les applications',
        'Search navigation and records': 'Rechercher dans la navigation et les enregistrements',
        'Nothing to display.': 'Aucun élément à afficher.',
        'Close': 'Fermer',
        'Choose files': 'Choisir des fichiers',
        'Drag files here or choose files to attach.': 'Glissez les fichiers ici ou sélectionnez-les.',
        'No matching commands': 'Aucune commande correspondante',
        'Complete': 'Terminé',
        'Failed': 'Échec',
        'In progress…': 'En cours…',
        'complete': 'terminé',
        'Loading workspace': "Chargement de l'espace de travail",
        'Record value comparison': 'Comparaison des valeurs',
        'Field': 'Champ',
        'Previous': 'Précédent',
        'Current': 'Actuel',
        'Reference': 'Référence',
        'Loading': 'Chargement',
        'Nothing here yet': 'Aucun résultat pour le moment',
        'Unable to load': 'Chargement impossible',
        'Access denied': 'Accès refusé',
        'You are offline': 'Vous êtes hors ligne',
        'Not found': 'Introuvable',
        'Try again': 'Réessayer',
        'Retry operation': 'Réessayer l’opération',
        'Cancel': 'Annuler',
        'Contact support': 'Contacter le support',
        'Remove': 'Supprimer',
        'Configuration saved by the application provider.': 'Configuration enregistrée.',
        "Configuration": "Configuration",
        "Temporary filter": "Filtre temporaire",
        "No active conditions": "Aucune condition active",
        "Edit conditions": "Modifier les conditions",
        "Add condition": "Ajouter une condition",
        "Apply": "Appliquer",
        "Clear values": "Effacer les valeurs",
        "Reset": "Réinitialiser",
        "Refresh": "Actualiser",
        "Filter settings": "Paramètres de filtre",
        "Configuration name": "Nom de la configuration",
        "Save configuration": "Enregistrer la configuration",
        "Save with values": "Enregistrer avec les valeurs",
        "Save as": "Enregistrer sous",
        "Save as copy": "Enregistrer une copie",
        "Delete configuration": "Supprimer la configuration",
        "Apply filter": "Appliquer le filtre",
        "Advanced filter conditions": "Conditions de filtrage avancées",
        "Property": "Propriété",
        "Operator": "Opérateur",
        "Value": "Valeur",
        "Match": "Correspondance",
        "Add group": "Ajouter un groupe",
        'Columns': 'Colonnes',
        'Apply to': 'Appliquer à',
        'selected': 'sélectionnés',
        'Select all rows': 'Sélectionner toutes les lignes',
        'Select': 'Sélectionner',
        'Expand': 'Développer',
        'Collapse': 'Réduire',
        'Move': 'Déplacer',
        'earlier': 'plus tôt',
        'later': 'plus tard',
        'Resize': 'Redimensionner',
        'Combine rules': 'Combiner les règles',
        'Match all (AND)': 'Toutes les conditions (ET)',
        'Match any (OR)': 'Au moins une (OU)',
        'Add condition group': 'Ajouter un groupe de conditions',
        'Group': 'Groupe',
        'Remove group': 'Supprimer le groupe',
        'Please complete the required information before continuing.': 'Veuillez remplir les champs requis avant de continuer.',
        'Back': 'Retour',
        'Next': 'Suivant',
        'Finish': 'Terminer',
        'More actions': 'Autres actions',
        'Print document': 'Imprimer le document',
        'Export document': 'Exporter le document',
        'Print-ready document': 'Document prêt à imprimer',
        'Interactive grid with expandable rows, selectable records and column layouts': 'Tableau interactif avec lignes extensibles et sélection',
        experience: "Expérience applicative",
        experienceCenter: "Centre d’expérience",
        patterns: "Modèles applicatifs",
        personalization: "Personnalisation",
        overview: "Aperçu",
        records: "Demandes de service",
        detail: "Modèle de détail",
        masterDetail: "Maître-détail",
        inlineEditing: "Modification intégrée",
        themeStudio: "Studio de thèmes",
        visualizations: "Visualisations",
        states: "États et accessibilité",
        businessObjects: "Objets métier",
        overviewTitle: "Modèles applicatifs composables",
        overviewIntro:
          "Un environnement neutre de données simulées présentant les fondations Inteacc de liste, détail, formulaire, recherche et visualisation."
      }
    }
  }
});

export default i18n;
